import { render, staticRenderFns } from "./ParentInfoModal.vue?vue&type=template&id=e0b99ed4&"
import script from "./ParentInfoModal.vue?vue&type=script&lang=js&"
export * from "./ParentInfoModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports